module.exports = __webpack_public_path__ + "static/img/975P_44.be54dc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/award_pieces/975P_44.jpg
// module id = 199
// module chunks = 1